module.exports = __webpack_public_path__ + "static/media/Business-Insider.9a70c613.svg";